module.exports = __webpack_public_path__ + "static/media/nn.24250f52.png";